// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2342":"0280a382","4753":"c3a71a48","6932":"65fd8607"}[chunkId] + ".chunk.css";
};